module.exports = __webpack_public_path__ + "img/129.5da19241.jpg";